import { IGridElement, InitialLink, ISheetHeaders } from '../../types';

export const createRow = (
  headers: ISheetHeaders,
  linkData?: InitialLink
): IGridElement[] =>
  headers.map((h) => {
    const isSelect = h.type === 'select';
    const readOnly = isSelect && h.options.length === 1;
    let value = null;
    if (linkData) {
      const parameter = linkData.find((p) => p.name === h.label);
      if (parameter) {
        if (!isSelect) {
          value = parameter.value;
        } else {
          const option = h.options.find((o) => o.label === parameter.value);
          value = option ? String(option.value.id) : null;
        }
      }
    } else {
      value = readOnly ? String(h.options[0].value.id) : null;
    }
    return {
      value,
      readOnly,
      type: h.type,
      isTargetUrl: h.targetUrl,
      options: h.options,
    };
  });



// WEBPACK FOOTER //
// ./src/views/LinkCreateBulk/components/services/createRow.ts